import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { DropdownOptionsType } from '../ReactreeUtils.js';
import Translate from '../../../core/Translate';

class ReactreeDropdown extends Component {
	constructor(props) {
		super(props);

		this.handleAddClick = this.handleAddClick.bind(this);
		this.handleRenameClick = this.handleRenameClick.bind(this);
		this.handleRemoveClick = this.handleRemoveClick.bind(this);
		this.getDropdownState = this.getDropdownState.bind(this);

		this.state = this.getDropdownState(props);
	}

	componentWillReceiveProps(nextProps) {
		this.setState(this.getDropdownState(nextProps));
	}

	shouldComponentUpdate(nextProps, nextState) {
		if (nextState.top !== this.state.top) {
			return true;
		}

		if (nextState.left !== this.state.left) {
			return true;
		}

		if (nextState.isDropdownOpen !== this.state.isDropdownOpen) {
			return true;
		}
		return false;
	}

	getDropdownState(props) {
		const dropdownOptions = props.dropdownOptions;
		const targetElement = dropdownOptions.targetElement;
		const newState = {
			isRoot: !!dropdownOptions.isRoot
		};

		if (!targetElement) {
			newState.isDropdownOpen = false;
		} else {
			const clientRect = targetElement.getBoundingClientRect();
			newState.top = clientRect.bottom;
			newState.left = clientRect.left;
			newState.isDropdownOpen = true;
		}

		return newState;
	}

	handleAddClick(event) {
		if (typeof this.props.dropdownOptions.onAddClick === 'function') {
			this.props.dropdownOptions.onAddClick(event);
		}
	}

	handleRenameClick(event) {
		if (typeof this.props.dropdownOptions.onRenameClick === 'function') {
			this.props.dropdownOptions.onRenameClick(event);
		}
	}

	handleRemoveClick(event) {
		if (typeof this.props.dropdownOptions.onRemoveClick === 'function') {
			this.props.dropdownOptions.onRemoveClick(event);
		}
	}

	render() {
		const dropdownPosition = {
			top: this.state.top,
			left: this.state.left
		}
		const canModify = !this.state.isRoot;

		const addButton = <a className="reactree-dropdown-item" onClick={this.handleAddClick}>{Translate.get("$S_str_Add")}</a>;
		const renameButton = canModify ? <a className="reactree-dropdown-item" onClick={this.handleRenameClick}>{Translate.get("$S_str_Rename")}</a> : null;
		const removeButton = canModify ? <a className="reactree-dropdown-item" onClick={this.handleRemoveClick}>{Translate.get("$S_str_Delete")}</a> : null;

		return (
			<div className={cx('reactree-dropdown-menu', { 'hide': !this.state.isDropdownOpen })} style={dropdownPosition}>
				{addButton}
				{renameButton}
				{removeButton}
			</div>
		);
	}
}

ReactreeDropdown.propTypes = {
	dropdownOptions: DropdownOptionsType
};

export default ReactreeDropdown;


// WEBPACK FOOTER //
// ./resources/WEB-INF/src/ui/Reactree/ReactreeDropdown/index.jsx